import React from "react"
import {Experience} from "../components/experience"



export const ExperiencePage: React.FC = () =>{
  return (
    <div className="page">
      <Experience/>
    </div>

    )
}